/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { getAssetsBatchDataError } from '@/services/asset-batches'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

export const useSetValidationsTable = ({ reloadItems }) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const [currentIds, setCurrentIds] = useState({})
  const [currentData, setCurrentData] = useState(null)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { batchId } = useParams()
  const handleCloseModal = () => {
    setCurrentData(null)
    setModalIsOpen(false)
    reloadItems()
  }
  const handleOpenDeleteModal = (dataId) => {
    setModalIsOpen(false)
    setDeleteModalIsOpen(true)
    setCurrentIds({
      batchId,
      dataId
    })
  }
  const handleOpenModal = async (dataId) => {
    setModalIsOpen(true)
    const worksBatchData = await getAssetsBatchDataError(dataId, getAccessToken)
    setCurrentData(worksBatchData)
    setIsLoading(false)
    setCurrentIds({
      batchId,
      dataId
    })
  }
  const handleCloseDeleteModal = async () => {
    setDeleteModalIsOpen(false)
    reloadItems()
  }

  return {
    currentData,
    currentIds,
    deleteModalIsOpen,
    handleCloseModal,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenModal,
    isLoading,
    modalIsOpen
  }
}
